import { Switch } from "@progress/kendo-react-inputs"
import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { editCaseManDocumentRequest } from "../../../../../services/caseManService/model/caseMan/CaseManagementSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";

function ImagingReportRequest(){
    const dispatch = useAppDispatch();
    const caseMan = useAppSelector((state) => state.caseManagement.caseManagement);

    return <React.Fragment>
        <div>
            <label>Imaging Report</label><br/>
            <Switch value={caseMan.documentRequest?.imagingReport}
                checked={caseMan.documentRequest?.imagingReport}
                onChange={(e)=>dispatch(editCaseManDocumentRequest(new ReduxUpdate('imagingReport',e.target.value)))}/>
        </div>
    </React.Fragment>
}
export {ImagingReportRequest}